<template>
  <div>
    <article v-bind:class="['page-content', {'border-bottom' : bordered }]" v-if="content">
      <div class="container narrow" v-html="content.value" data-aos="fade-in">
      </div>
    </article>
  </div>
</template>

<script>
  export default {
    name: 'PageContent',
    props: {
      bordered: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        content: null,
      };
    },
    methods: {
      loadContent: function (content) {
        this.content = content;
      }
    }
  }
</script>
